import { LOCALES, DEFAULT_LOCALE, COOKIE_NAME, type Locale } from "./types";

function readCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : undefined;
}

function writeCookie(name: string, value: string) {
  if (typeof document === "undefined") return;
  // 1 year
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
}

function isLocale(value: string | undefined): value is Locale {
  return value === "fr" || value === "en" || value === "nl";
}

export function detectInitialLocale(): Locale {
  // Cookie first (explicit user choice)
  const fromCookie = readCookie(COOKIE_NAME);
  if (isLocale(fromCookie)) return fromCookie;

  // navigator.languages
  if (typeof navigator !== "undefined") {
    const candidates = navigator.languages ?? [navigator.language];
    for (const raw of candidates) {
      if (!raw) continue;
      const tag = raw.toLowerCase().split("-")[0];
      if (isLocale(tag)) return tag as Locale;
    }
  }

  return DEFAULT_LOCALE;
}

export function persistLocale(locale: Locale) {
  writeCookie(COOKIE_NAME, locale);
}

export { LOCALES, DEFAULT_LOCALE, isLocale };
